import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Notificacion } from 'src/app/models/Notificacion';
import { NotificacionService } from 'src/app/services/notificacion.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { firstValueFrom } from 'rxjs';
import { LoadingService } from 'src/app/services/loading.service';
import { AuthService } from 'src/app/services/auth.service';


@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.css'],
    standalone: false
})
export class NotificationsComponent implements OnInit {
  private readonly _notificacionService = inject(NotificacionService);
  private readonly _usuarioService = inject(UsuarioService);
  private readonly _authService = inject(AuthService);
  private readonly _loadingService = inject(LoadingService);

  private readonly _router = inject(Router);
  private readonly _location = inject(Location);

  showHelp = signal(false);

  helpText = computed(() => {
    const perfil = this._usuarioService.usuario().id_perfil ?? 2;
    switch (perfil) {
      case 1:
        return 'Desde aquí podés ver y gestionar todas las notificaciones del sistema, incluyendo alertas operativas y avisos importantes para la administración.';
      case 2:
        return 'Acá vas a encontrar avisos importantes sobre turnos, compras, recordatorios y accesos rápidos a acciones relevantes dentro de la app.';
      case 3:
        return 'En esta sección se muestran notificaciones sobre solicitudes de turnos, confirmaciones, cancelaciones y mensajes de tus pacientes.';
      case 4:
        return 'Aquí recibís notificaciones relacionadas con pedidos, aprobaciones, respuestas de clientes y novedades de tu comercio.';
      default:
        return 'En esta pantalla se muestran las notificaciones más importantes relacionadas con tu actividad dentro de la aplicación.';
    }
  });

  get notificaciones(): Notificacion[] {
    return this._notificacionService.notificaciones ?? [];
  }

  get idPerfil(): number {
    return this._usuarioService.usuario().id_perfil ?? 2;
  }

  async ngOnInit(): Promise<void> {
    document.documentElement.scrollTop = 0;

    await this._loadingService.run(async () => {
      try {
        await this._authService.ensureSession();
        this._notificacionService.obtenerNotificaciones();
      } catch (e) {
        console.error(e);
        this._router.navigate(['/sign-in']);
      }
    });
  }

  toggleHelp(): void {
    this.showHelp.update(v => !v);
  }

  closeHelp(): void {
    this.showHelp.set(false);
  }

  async leerNotificaciones(notificacion: Notificacion): Promise<void> {
    if (!notificacion.b_visto) {
      notificacion.b_visto = true;
      try {
        await firstValueFrom(this._notificacionService.updateNotificacion(notificacion));
      } catch (e) {
        console.error('Error al actualizar notificación:', e);
      }
    }

    if (notificacion.x_link?.trim()) {
      this._router.navigate([notificacion.x_link]);
    } else {
      this._router.navigate(['/notificacion', notificacion.id]);
    }
  }

  back(): void {
    this._location.back();
  }
}
